module.exports = __webpack_public_path__ + "img/cv.efdd177a.svg";